<section class="sen-welcome-info text-center">
    <img src="{{imagePath.loginSENLogo}}" class="mb-4">
    <h5 class="mt-3 sen-active-color">{{translate.getLng('SP_WELCOME_INFO1')}}</h5>
    <p class="my-4 set-blue-color">{{translate.getLng('SP_WELCOME_INFO2')}}</p>
    <p class="text-justify">{{translate.getLng('SP_WELCOME_INFO3')}}</p>
    <p class="text-justify">{{translate.getLng('SP_WELCOME_INFO4')}}</p>
</section>